import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from "@angular/core";
import { AuxJasper } from "../../entidades/entidades";
import { JasperService } from "../../servicios/jasper.service";

@Component({
  selector: "app-visor",
  templateUrl: "./visor.component.html",
  styleUrls: ["./visor.component.css"],
})


export class VisorComponent implements OnInit {
  @ViewChild("iframe", { static: true }) iframe: ElementRef;
  public formato: string;
  public progressBarEstatus: boolean = false;

  @Input("auxJasper") auxJasper: AuxJasper;
  @Output() progressBar2 = new EventEmitter();
  @Output() archivoGenerado = new EventEmitter<void>();
  message: string = "Hola Mundo!"

  ocultarProcesando: boolean = true;
  ocultarReporte: boolean = true;
  oculatarSinResultado: boolean = true;
  constructor(private jasperService: JasperService) { }

  ngOnInit() {
  }

  async ngOnChanges() {
    await this.imprimeSolicitud(this.auxJasper);
  }

  async imprimeSolicitud(auxJasper: AuxJasper) {
    try {
      this.ocultarProcesando = false;
      const fechaActual = new Date();
      const dia = String(fechaActual.getDate()).padStart(2, '0'); // Asegura 2 dígitos (ej: 01, 11)
      const mes = String(fechaActual.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
      const año = fechaActual.getFullYear();
      const fechaFormateada = `${dia}${mes}${año}`; // Formato ddmmyyyy
      const nombreArchivo = `${this.auxJasper.JasperReport.nombreReporte}_${fechaFormateada}`;

      //limpia el iframe
      this.iframe.nativeElement["src"] = "about:blank";
      const datos = await this.jasperService
        .getReportJasper(auxJasper)
        .toPromise();

      if (auxJasper.JasperReport.tipo == "pdf") {
        if (auxJasper.JasperReport.imprimir == true) {
          this.formato = "application/pdf";
          this.progressBar2.emit(this.progressBarEstatus);
          
          //valida si el reporte es de recepcion de recibos o contenga la cadena "EstadoDeCuenta"
          if (this.auxJasper.JasperReport.nombreReporte == "EstadoDeCuenta" && (this.auxJasper.JasperReport.urlGeneral != null || this.auxJasper.JasperReport.urlGeneral != "")) {
              this.saveAsFileRecibos(
                datos,
                this.auxJasper.JasperReport.urlGeneral,
                this.formato,
                auxJasper.JasperReport.tipo
              );
              this.archivoGenerado.emit();
          } else if (this.auxJasper.JasperReport.nombreReporte == "EstadoDeCuenta" && this.auxJasper.JasperReport.urlGeneral == null) {
            this.saveAsFile(
              datos,
              this.auxJasper.JasperReport.nombreReporte,
              this.formato,
              auxJasper.JasperReport.tipo
            );  
          } else if (this.auxJasper.JasperReport.nombreReporte == "RecepcionDeRecibos") {
            this.saveAsFile(
              datos,
              this.auxJasper.JasperReport.nombreReporte,
              this.formato,
              auxJasper.JasperReport.tipo
            );
          }else{
            this.saveAsFile(
            datos,
            nombreArchivo,
            this.formato,
            auxJasper.JasperReport.tipo
            );
          }
        } else {
           this.iframe.nativeElement["src"] =
            "data:application/pdf;base64," + datos;
        }
      } else if (auxJasper.JasperReport.tipo == "xlsx") {
        this.formato = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        this.saveAsFile(
          datos,
          nombreArchivo,
          this.formato,
          auxJasper.JasperReport.tipo
        );
      } else if (auxJasper.JasperReport.tipo == "csv") {
        this.formato = "text/csv";
        this.saveAsFile(
          datos,
          nombreArchivo,
          this.formato,
          auxJasper.JasperReport.tipo
        );
      } else if (auxJasper.JasperReport.tipo == "docx") {
        this.formato = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        this.saveAsFile(
          datos,
          nombreArchivo,
          this.formato,
          auxJasper.JasperReport.tipo
        );
      }

      this.ocultarProcesando = true;
      this.ocultarReporte = false;
      this.progressBar2.emit(this.progressBarEstatus);

    } catch (e) {
      this.ocultarReporte = true;
      this.ocultarProcesando = true;
      this.oculatarSinResultado = false;
    } finally {
    }
  }

  saveAsFile(
    buffer: any,
    fileName: string,
    formato: string,
    EXTENSION: string
  ): void {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      "data:" + formato + ";base64," + buffer,
      fileName + new Date().getTime() + "." + EXTENSION
    );
  }

  saveAsFileRecibos(
    buffer: any,
    fileName: string,
    formato: string,
    EXTENSION: string
  ): void {
    var FileSaver = require("file-saver");
    FileSaver.saveAs(
      "data:" + formato + ";base64," + buffer,
      fileName + "." + EXTENSION
    );
  }

  ngOnDestroy() { }
}

